"use client";
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Bot } from "lucide-react";
import ChatView from "../../CycleBot/ChatView/ChatView";
import "./CycleChatBubble.css";

export default function CycleChatBubble({
  messages = [],
  isTyping = false,
  onSend,
  onNewConversation,
  chatLimit,
}) {
  const { t } = useTranslation("cycle");
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  /* close on Escape */
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  return (
    <>
      {/* ── FAB (bottom-right, small circle with ?) ── */}
      <button
        className="ccb-fab"
        onClick={() => setOpen(true)}
        aria-label={t("cycleBot.chatView.title")}
      >
        <Bot size={20} strokeWidth={2} />
      </button>

      {/* ── Backdrop + Modal ── */}
      {open && (
        <div className="ccb-backdrop" onClick={() => setOpen(false)}>
          <div
            ref={panelRef}
            className="ccb-modal"
            role="dialog"
            aria-label={t("cycleBot.chatView.title")}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="ccb-modal__header">
              <div className="ccb-modal__header-left">
                <div className="ccb-modal__avatar">
                  <Bot size={24} color="#fff" strokeWidth={2} />
                </div>
                <div className="ccb-modal__info">
                  <span className="ccb-modal__title">{t("cycleBot.chatView.title")}</span>
                  <span className="ccb-modal__sub">{t("cycleBot.chatView.subtitle")}</span>
                </div>
              </div>
              <button
                className="ccb-modal__close"
                onClick={() => setOpen(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            {/* Chat body */}
            <div className="ccb-modal__body">
              <ChatView
                messages={messages}
                onSend={onSend}
                onNewConversation={onNewConversation}
                isTyping={isTyping}
                chatLimit={chatLimit}
                embedded
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
